"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACTION_MAP = void 0;
exports["default"] = Log;
var _react = _interopRequireWildcard(require("react"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _Context = _interopRequireDefault(require("../../components/LicensingAdminContext/Context"));
var _query = _interopRequireDefault(require("./query.graphql"));
var _ActionRenders = _interopRequireDefault(require("./ActionRenders"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ACTION_MAP = exports.ACTION_MAP = {
  'ownedLicense:create': {
    displayText: 'Create',
    renderComponent: _ActionRenders["default"].OwnedLicenseCreate
  },
  'ownedLicense:delete': {
    displayText: 'Revoke',
    renderComponent: _ActionRenders["default"].OwnedLicenseDelete
  },
  'ownedLicense:expire': {
    displayText: 'Expire',
    renderComponent: _ActionRenders["default"].OwnedLicenseExpire
  },
  'ownedLicense:renew': {
    displayText: 'Renew',
    renderComponent: _ActionRenders["default"].OwnedLicenseRenew
  },
  'heldLicense:assign': {
    displayText: 'Assign',
    renderComponent: _ActionRenders["default"].OwnedLicenseAssign
  },
  'heldLicense:create': {
    displayText: 'Add',
    renderComponent: _ActionRenders["default"].HeldLicenseCreate
  },
  'heldLicense:changeQuantity': {
    displayText: 'Modify',
    renderComponent: _ActionRenders["default"].HeldLicenseModify
  },
  'heldLicense:delete': {
    displayText: 'Delete',
    renderComponent: _ActionRenders["default"].HeldLicenseDelete
  },
  'heldLicense:transfer': {
    displayText: 'Transfer',
    renderComponent: _ActionRenders["default"].HeldLicenseTransfer
  },
  'voucher:create': {
    displayText: 'Voucher Create',
    renderComponent: _ActionRenders["default"].VoucherCreate
  },
  'voucher:redeem': {
    displayText: 'Voucher Redeem',
    renderComponent: _ActionRenders["default"].VoucherRedeem
  },
  'voucher:delete': {
    displayText: 'Voucher Delete',
    renderComponent: _ActionRenders["default"].VoucherDelete
  },
  'voucher:changeQuantity': {
    displayText: 'Voucher Modify',
    renderComponent: _ActionRenders["default"].VoucherModify
  }
};
function Log() {
  var _useContext = (0, _react.useContext)(_Context["default"]),
    selectedProduct = _useContext.selectedProduct;
  function renderAction(_ref) {
    var value = _ref.value;
    if (value in ACTION_MAP) {
      return ACTION_MAP[value].displayText;
    }
    return value;
  }
  function renderDescription(renderProps) {
    var action = renderProps.row.action;
    var RenderComponent = ACTION_MAP[action].renderComponent;
    if (!RenderComponent) {
      console.error('Could not find render function for action ' + action);
      return /*#__PURE__*/_react["default"].createElement("span", null);
    }
    return /*#__PURE__*/_react["default"].createElement(RenderComponent, renderProps.row);
  }
  var tableProps = {
    query: _query["default"],
    graphqlVariables: {
      productId: (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.productId) || -1
    },
    orderBy: 'createdAt',
    rowKey: 'logId',
    isAscentOrder: false,
    handle: 'licensingLog',
    columns: [{
      name: 'createdAt',
      label: 'Action Time',
      filter: true,
      sort: true,
      filterSettings: {
        type: 'date'
      }
    }, {
      name: 'action',
      label: 'Action',
      filter: true,
      sort: true,
      render: renderAction,
      filterSettings: {
        type: 'selectbox',
        field: 'action',
        options: Object.keys(ACTION_MAP).map(function (k) {
          return {
            value: k,
            label: ACTION_MAP[k].displayText
          };
        })
      }
    }, {
      name: 'actingPawn.user.username',
      label: 'Action Taken By',
      filter: true,
      sort: true
    }, {
      name: 'actingPawn.pawn.roleName',
      label: 'Role',
      filter: true,
      sort: true
    }, {
      name: 'description',
      label: 'Description',
      filter: false,
      sort: false,
      render: renderDescription
    }, {
      name: 'licensee',
      label: 'Licensee',
      filter: true,
      sort: true
    }, {
      name: 'voucher',
      label: 'Voucher',
      filter: true,
      sort: true
    }, {
      name: 'fromGroup',
      label: 'From Group',
      filter: true,
      sort: true
    }, {
      name: 'toGroup',
      label: 'To Group',
      filter: true,
      sort: true
    }]
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], tableProps);
}